import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMachinesWithFilters } from './store/slice';
import MachineTopHead from './machine-top-head';
import MachineContent from './machine-content';
import MachineModals from './machine-modals';
import { actions as machinesAction } from './store/slice';

const { resetFilters } = machinesAction;

const MachineView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchMachinesWithFilters());
    // dispatch(fetchMachines({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Machine</h4>
              </div>
            </div>
            <MachineTopHead />
          </div>
          <MachineContent />
          <MachineModals />
        </div>
      </div>
    </div>
  );
};

export default MachineView;
